(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/product-start-page/assets/javascripts/footer/views/footer-items.js') >= 0) return;  svs.modules.push('/components/app/product-start-page/assets/javascripts/footer/views/footer-items.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.app.productStartPage.footer.views.FooterItems = Backbone.Marionette.CompositeView.extend({
    className: 'product-start-page-footer gutter-xs-0',
    childView: svs.app.productStartPage.footer.views.FooterItem,
    childViewContainer: '.row',
    template: function(data) {
      return svs.app.product_start_page.templates.footer_items(data);
    },
    childViewOptions: function(model, index) {
      return {
        itemIndex: index,
        numberOfFooterItems: this.collection.length
      };
    },
    onAttach: function() {
      this.$el.addClass('product-start-page-footer-' + this.model.get('branding'));
    }
  });
})(Backbone, _, svs);

 })(window);